import React from "react";

const Notes = (props: any) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_222_10)">
        <path
          d="M15.1647 5.0909H10.5611C10.4746 5.0909 10.3916 5.05642 10.3304 4.99505C10.2692 4.93367 10.2349 4.85044 10.2349 4.76364V1.83637C10.2349 1.74957 10.2692 1.66631 10.3304 1.60493C10.3916 1.54356 10.4746 1.50908 10.5611 1.50908C10.6476 1.50908 10.7306 1.54356 10.7918 1.60493C10.853 1.66631 10.8873 1.74957 10.8873 1.83637V4.43635H15.1647C15.2513 4.43635 15.3342 4.47083 15.3954 4.53221C15.4566 4.59358 15.491 4.67684 15.491 4.76364C15.491 4.85044 15.4566 4.93367 15.3954 4.99505C15.3342 5.05642 15.2513 5.0909 15.1647 5.0909Z"
          fill="#4D4D4D"
        />
        <path
          d="M15.1645 20H0.963924C0.877399 20 0.794456 19.9655 0.733274 19.9041C0.672092 19.8428 0.637695 19.7595 0.637695 19.6727V0.327273C0.637695 0.240475 0.672092 0.157242 0.733274 0.0958667C0.794456 0.0344911 0.877399 -1.39933e-05 0.963924 -1.39933e-05H10.7331C10.8175 -0.000249305 10.8987 0.0323408 10.9596 0.0909006L15.3911 4.53637C15.4528 4.59605 15.4886 4.67769 15.4908 4.76364V8.65455C15.4908 8.74135 15.4564 8.82458 15.3952 8.88595C15.334 8.94733 15.2511 8.98181 15.1645 8.98181C15.078 8.98181 14.995 8.94733 14.9338 8.88595C14.8726 8.82458 14.8382 8.74135 14.8382 8.65455V4.9L10.5971 0.654533H1.28114V19.3455H14.8745V11.5091C14.8745 11.4223 14.9089 11.339 14.9701 11.2777C15.0312 11.2163 15.1142 11.1818 15.2008 11.1818C15.2873 11.1818 15.3703 11.2163 15.4315 11.2777C15.4926 11.339 15.527 11.4223 15.527 11.5091V19.6909C15.5248 19.7356 15.5135 19.7793 15.4938 19.8194C15.4741 19.8596 15.4464 19.8952 15.4124 19.9242C15.3785 19.9531 15.339 19.9748 15.2963 19.9878C15.2537 20.0009 15.2088 20.005 15.1645 20Z"
          fill="#4D4D4D"
        />
        <path
          d="M12.4728 8.84545H3.52838C3.44185 8.84545 3.35885 8.81097 3.29767 8.7496C3.23649 8.68822 3.20215 8.60499 3.20215 8.51819C3.20215 8.43139 3.23649 8.34813 3.29767 8.28676C3.35885 8.22538 3.44185 8.1909 3.52838 8.1909H12.4728C12.5594 8.1909 12.6423 8.22538 12.7035 8.28676C12.7647 8.34813 12.7991 8.43139 12.7991 8.51819C12.7991 8.60499 12.7647 8.68822 12.7035 8.7496C12.6423 8.81097 12.5594 8.84545 12.4728 8.84545Z"
          fill="#4D4D4D"
        />
        <path
          d="M12.4728 12.0727H3.52838C3.44185 12.0727 3.35885 12.0382 3.29767 11.9769C3.23649 11.9155 3.20215 11.8323 3.20215 11.7455C3.20215 11.6587 3.23649 11.5754 3.29767 11.514C3.35885 11.4527 3.44185 11.4182 3.52838 11.4182H12.4728C12.5594 11.4182 12.6424 11.4527 12.7035 11.514C12.7647 11.5754 12.7991 11.6587 12.7991 11.7455C12.7991 11.8323 12.7647 11.9155 12.7035 11.9769C12.6424 12.0382 12.5594 12.0727 12.4728 12.0727Z"
          fill="#4D4D4D"
        />
        <path
          d="M12.4728 15.3H3.52838C3.44185 15.3 3.35885 15.2655 3.29767 15.2041C3.23649 15.1428 3.20215 15.0595 3.20215 14.9727C3.20215 14.8859 3.23649 14.8027 3.29767 14.7413C3.35885 14.6799 3.44185 14.6455 3.52838 14.6455H12.4728C12.5594 14.6455 12.6423 14.6799 12.7035 14.7413C12.7647 14.8027 12.7991 14.8859 12.7991 14.9727C12.7991 15.0595 12.7647 15.1428 12.7035 15.2041C12.6423 15.2655 12.5594 15.3 12.4728 15.3Z"
          fill="#4D4D4D"
        />
      </g>
      <defs>
        <clipPath id="clip0_222_10">
          <rect
            width="14.8531"
            height="20"
            fill="white"
            transform="translate(0.637695)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Notes;
